export default {
  en: {
    btnSend: 'Send',
    btnSendingData: 'Sending',
    btnVerifying: 'Verifying connection',
    connectionError: 'Connection Error',
    logStatus: {
      connectionFail: 'Connection failed.',
      connectionSuccess: 'Connection successful.',
      connectionVerifying: 'Verifying connection...',
      parsingErrorsSending: 'Parsing errors sending...',
      parsingErrorsSuccess: 'Parsing errors sent.',
      parsingErrorsFail: 'Parsing errors failed.',
    },
    parsingErrors: 'Parsing errors',
    statusTitle: 'Status',
    title: 'Send Diagnostics',
  },
};
